import { ReactNode } from "react";
import { getClassName } from "@pairtreefamily/utils";
import Card from "../card";

export type GalleryTileProps = {
  children: ReactNode;
  size: TileSize;
  className?: string;
};

export type TileSize = "sm" | "md" | "lg" | "tall";

export function GalleryTile(props: GalleryTileProps) {
  let className = getClassName(
    "overflow-hidden",
    props.size === "sm" && "col-span-1 row-span-1",
    props.size === "md" && "sm:col-span-2 row-span-1",
    props.size === "lg" && "sm:col-span-2 row-span-2",
    props.size === "tall" && "col-span-1 row-span-2",
    props.className,
  );

  return <Card className={className}>{props.children}</Card>;
}

export default GalleryTile;
